<template>
  <div class="main">
    <div class="sitename">
      <router-link to="/">&copy; Shota KONO</router-link>
    </div>
    <div class="about">
      <router-link to="/about">About</router-link>
    </div>
    <div class="contact">
      <a href="mailto:cono.shota@gmail.com">Contact</a>
    </div>
    <div class="title_pdf">
      <a href="javascript:void(0)" @click="clickPDF">works</a>
    </div>
    <div v-show="isDisplay" id="pdf" class="pc_pdf">
      <object data="../../static/pdf/works.pdf" type="application/pdf" width="100%" height="100%"></object>
    </div>
    <div class="sp_pdf">
      <a href="../../static/pdf/works.pdf" target="_blank">works</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  metaInfo: {
    title: 'Shota KONO | Photography',
    // titleTemplate: '%s | shotakono.net',
    meta: [{ vmid: 'description', name: 'description', content: 'index page | shotakono Photography website 写真家 河野翔大 オフィシャルウェブサイト' }]
  },
  data () {
    return {
      isDisplay: false
    }
  },
  methods: {
    /* PDFクリックイベント */
    clickPDF: function () {
      if (this.isDisplay) {
        this.isDisplay = false
      } else {
        var element = document.getElementById('pdf')
        element.scrollIntoView(true)
        this.isDisplay = true
      }
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.main {
  margin-left: 2%;
}
.sitename {
  margin-bottom: 6%;
}
.sitename a {
  color: #000000;
  font-size: 14px;
}
.about {
  margin-bottom: 2.2%;
}
.about a {
  color: #ff0000;
}
.contact {
  margin-bottom: 8%;
}
.contact a {
  color: #ff0000;
}
.title_pdf {
  display: none;
}
.title_pdf a {
  color: #000000;
}
.pc_pdf {
  display: none;
}
.sp_pdf {
  display: inline;
}
.sp_pdf a {
  color: #000000;
}
@media (min-width: 768px) {
  .main {
    margin-left: 10px;
  }
  .sitename {
    margin-bottom: 14px;
  }
  .about {
    margin-bottom: 6px;
  }
  .contact {
    margin-bottom: 28px;
  }
}
@media screen and (min-width: 992px) {
  .title_pdf {
    display: inline;
  }
  .pc_pdf {
    display: inherit;
    width: 1000px;
    height: 760px;
    margin-top: 48px;
  }
  .sp_pdf {
    display: none;
  }
}
</style>
<!-- a {
  text-decoration: none;
}
.main {
  margin-left: 2%;
}
.sitename {
  margin-bottom: 2%;
}
.sitename a {
  color: #000000;
}
.about {
  margin-bottom: 1.3%;
}
.about a {
  color: #ff0000;
}
.contact {
  margin-bottom: 3.5%;
}
.contact a {
  color: #ff0000;
}
.link_pdf {
  display: none;
}
.link_pdf a {
  color: #000000;
}
.pc_pdf {
  display: none;
}
.sp_pdf {
  display: inline;
}
.sp_pdf a {
  color: #000000;
}
@media (min-width: 768px) {
  .main {
    margin-left: 10px;
  }
  .sitename {
    margin-bottom: 14px;
  }
  .about {
    margin-bottom: 6px;
  }
  .contact {
    margin-bottom: 28px;
  }
  .link_pdf {
    display: inline;
  }
  .pc_pdf {
    display: inherit;
    height: 740px;
    margin-top: 48px;
  }
  .sp_pdf {
    display: none;
  }
}
@media screen and (min-width: 992px) {
  .pc_pdf {
    display: inherit;
    height: 1320px;
    margin-top: 48px;
  }
} -->


// WEBPACK FOOTER //
// src/components/Index.vue